<template>
	<transition
			appear
			:appear-active-class="$_inpDtPckr_styleInputTextFieldAnimation()">
		<v-row>
			<v-col>
				<v-dialog
						ref="dialog"
						v-model="show_"
						persistent
						width="300px">
					<template v-slot:activator="{ on }">
						<validation-provider
								:name="'InputDatePicker-' + contentKey"
								:rules="getValidationRules(contents[contentKey].rules)"
								v-slot="{ errors }">
							<v-text-field
									v-model="date_"
									
									:background-color="$_inpDtPckr_styleTextFieldBackgroundColor"
									:clearable="$_inpDtPckr_styleTextFieldClearable"
									:color="$_inpDtPckr_styleTextFieldColor"
									:counter="$_inpDtPckr_styleTextFieldCounter"
									:dark="$_inpDtPckr_styleTextFieldDark"
									:filled="$_inpDtPckr_styleTextFieldFilled"
									:flat="$_inpDtPckr_styleTextFieldFlat"
									:light="$_inpDtPckr_styleTextFieldLight"
									:outlined="$_inpDtPckr_styleTextFieldOutlined"
									:solo="$_inpDtPckr_styleTextFieldSolo"
									:solo-inverted="$_inpDtPckr_styleTextFieldSoloInverted"

									:append-icon="$_inpDtPckr_styleParamAppendIcon(contents[contentKey].params)"
									:append-outer-icon="$_inpDtPckr_styleParamAppendOuterIcon(contents[contentKey].params)"
									:prepend-icon="$_inpDtPckr_styleParamPrependIcon(contents[contentKey].params)"
									:prepend-inner-icon="$_inpDtPckr_styleParamPrependInnerIcon(contents[contentKey].params)"

									:hint="$_inpDtPckr_langParamHint(contents[contentKey].params)"
									:mask="$_inpDtPckr_langParamMask(contents[contentKey].params)"
									:message="$_inpDtPckr_langParamMessage(contents[contentKey].params)"
									:placeholder="$_inpDtPckr_langParamPlaceholder(contents[contentKey].params)"
									:prefix="$_inpDtPckr_langParamPrefix(contents[contentKey].params)"
									:suffix="$_inpDtPckr_langParamSuffix(contents[contentKey].params)"
									:type="$_inpDtPckr_langParamType(contents[contentKey].params)"

									:error-messages="errors"
									
									v-on="on"/>
						</validation-provider>
					</template>
					<v-date-picker v-model="date_" scrollable>
						<v-spacer></v-spacer>
						<v-btn	class="customVBtn"
								color="primary"
								text
								@click="$_inpDtPckr_close()">
							Cancel
						</v-btn>
						<v-btn	class="customVBtn"
								color="primary"
								text
								@click="$_inpDtPckr_save()">
							OK
						</v-btn>
					</v-date-picker>
				</v-dialog>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputDatePicker',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				show_: false,

				date_: null,

				inputDataState_: null
			}
		},
		computed: {
			// lang
			$_inpDtPckr_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamMask() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.mask;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpDtPckr_langParamType() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.type;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpDtPckr_styleInputTextField() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputTextField')
				}
			},
			$_inpDtPckr_styleInputTextFieldAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpDtPckr_styleInputTextField()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpDtPckr_styleTextField() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'textField')
			},
			$_inpDtPckr_styleTextFieldAppendIcon() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendIcon)
			},
			$_inpDtPckr_styleTextFieldAppendOuterIcon() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendOuterIcon)
			},
			$_inpDtPckr_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpDtPckr_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpDtPckr_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpDtPckr_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_inpDtPckr_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpDtPckr_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpDtPckr_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpDtPckr_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpDtPckr_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpDtPckr_styleTextFieldPrependIcon() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependIcon)
			},
			$_inpDtPckr_styleTextFieldPrependInnerIcon() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependInnerIcon)
			},
			$_inpDtPckr_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpDtPckr_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpDtPckr_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpDtPckr_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpDtPckr_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpDtPckr_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpDtPckr_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		},
		methods: {
			$_inpDtPckr_save() {
				const self_ = this;
				// input state
				const inputData_ = self_.getInputState('data')
				const key_ = self_.contentKey;
				inputData_[key_].answer = self_.date_;
				self_.setInputState('data', inputData_)

				self_.$_inpDtPckr_close()
			},
			$_inpDtPckr_close() {
				const self_ = this;

				self_.show_ = false;
			}
		}		
	}
</script>

<style scoped>
</style>
